import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { FilterViewLayoutModule } from '@go-modules/components/filter-view-layout/filter-view-layout.module';
import { NgxArchiveViewComponent } from './archive-view.component';
import {
	NgxArchiveTableViewComponent
} from '@go-modules/components/archive/archive-view/archive-table-view/archive-table-view.component';
import { OutsideClickModule } from '@go-modules/directives/outside-click';
import { GoMaterialModule } from '@go-modules/go-material.module';
import {
	NgxArchiveGridViewComponent
} from '@go-modules/components/archive/archive-view/archive-grid-view/archive-grid-view.component';
import { NgxArchiveCardModule } from '@go-modules/components/archive/archive-card/archive-card.module';
import { GridVirtualScrollViewportModule } from '@go-modules/components/grid-virtual-scroll-viewport/grid-virtual-scroll-viewport.module';
import { ArchivedListDataSource } from '@go-modules/services/archive';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';
import { ArchiveMenuModule } from '@go-modules/components/archive/archive-menu/archive-menu.module';
import { ArchiveZeroStateComponent } from './archive-zero-state/archive-zero-state.component';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { ReactiveFormsModule } from '@angular/forms';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { EllipsisWithCountModule } from '@go-modules/components/ellipsis-with-count/ellipsis-with-count.module';
import { ThumbnailModule } from '@go-modules/components/thumbnail/thumbnail.module';
import { LoadingModule } from '@go-modules/components/loading/loading.module';
import { ToggleGridListViewComponent } from '@go-modules/components/toggle-grid-list-view/toggle-grid-list-view.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FilterViewLayoutModule,
		OutsideClickModule,
		GoMaterialModule,
		NgxArchiveCardModule,
		GridVirtualScrollViewportModule,
		MenuModule,
		ArchiveMenuModule,
		NgxZeroStateModule,
		ReactiveFormsModule,
		GoSelectModule,
		EllipsisWithCountModule,
		ThumbnailModule,
		LoadingModule,
		ToggleGridListViewComponent
	],
	declarations: [
		NgxArchiveViewComponent,
		NgxArchiveTableViewComponent,
		NgxArchiveGridViewComponent,
		ArchiveZeroStateComponent
	],
	exports: [
		NgxArchiveViewComponent,
		NgxArchiveTableViewComponent,
		NgxArchiveGridViewComponent
	],
	providers: [
		TranslatePipe,
		ArchivedListDataSource
	]
})
export class NgxArchiveViewModule {}
